import { useAuthMutation } from "@l2r-front/l2r-auth"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

export function useLoginMutation(config = {}) {
    const url = "token/"
    return useAuthMutation(url, axiosInstance.post, {}, config)
}
